import React from "react";

/**
 * Mini parser de markdown inline: **negrita** y `código`.
 * Suficiente para los highlights de CHANGELOG sin meter react-markdown
 * (que añadiría ~50 KB al bundle). Si en el futuro necesitamos listas,
 * enlaces o cualquier cosa más, migrar a react-markdown.
 */
export function renderInlineMarkdown(text: string): React.ReactNode[] {
  const parts: React.ReactNode[] = [];
  let last = 0;
  let key = 0;
  const regex = /\*\*([^*]+?)\*\*|`([^`]+?)`/g;
  let match: RegExpExecArray | null;
  while ((match = regex.exec(text)) !== null) {
    if (match.index > last) parts.push(text.slice(last, match.index));
    if (match[1] !== undefined) {
      parts.push(<strong key={key++}>{match[1]}</strong>);
    } else if (match[2] !== undefined) {
      parts.push(
        <code
          key={key++}
          style={{
            background: "rgba(8,145,178,0.10)",
            padding: "1px 6px",
            borderRadius: 4,
            fontSize: "0.9em",
            color: "#0891b2",
          }}
        >
          {match[2]}
        </code>
      );
    }
    last = regex.lastIndex;
  }
  if (last < text.length) parts.push(text.slice(last));
  return parts;
}
